import { NgModule } from '@angular/core';
import { IntegerComponent } from './integer/integer.component';
import { DateComponent } from './date/date.component';
import { StringComponent } from './string/string.component';
import { CommonModule } from '@angular/common';
import { IntegerDateComponent } from './integer_date/integer-date.component';

@NgModule({
    imports: [
        CommonModule
    ],
 declarations: [
     IntegerComponent,
     IntegerDateComponent,
     StringComponent,
     DateComponent
 ],
 exports: [
     IntegerComponent,
     StringComponent,
     IntegerDateComponent,
     DateComponent
 ]
})
export class GeneralModule {

}
